<div class="modal-header">
    <h5 class="modal-title">Confirm Store Change</h5>
</div>

<div class="modal-body">
    Are you sure you want to change store to <strong>{{ storeName }}</strong>?
</div>

<div class="modal-footer">
    <button class="btn sd-custom-btn  rounded-2  btn-sm" (click)="confirm()">Yes</button>
    <button class="btn btn-danger rounded-2  btn-sm" (click)="cancel()">No</button>
</div>